import React, { useState, useContext, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useHistory } from "react-router-dom";
import CustomizedSnackbars from "../../components/alert/Alert";
import { onSignIn } from "../../auth/index";
import AuthContext from "../../auth/context";
import api from "../../services/api";
import perto from "../../images/perto.png";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Box, createTheme, Grid, styled, ThemeProvider } from "@mui/material";
import { getQueryParams } from "../../helpers/helpers";

let text = "";
let tipo = "";

export default function Login({ location, validarSessao }) {
  const { atualizarUsuario } = useContext(AuthContext);
  const [alerta, setAlerta] = useState(false);
  const [CPF, setCPF] = useState("");
  const [senha, setSenha] = useState("");
  const history = useHistory();
  const [msgAlerta, setMsgAlerta] = useState("");

  useEffect(() => {
    const parametros = getQueryParams(location.search);
    if (parametros.timeout === "1")
      setMsgAlerta(
        "Sua sessão expirou. Refaça o login para restabelecer  o acesso."
      );
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const credenciais = {
      CPF: CPF,
      senha: senha,
    };

    if (!CPF || !senha) {
      text = "Preencha CPF e Senha para acesso";
      tipo = "warning";
      alertMsg();
    } else {
      console.log("credenciais", credenciais);
      api
        .post("usuarios/autenticar", credenciais)
        .then((res) => {
          // const resultadoLogin = res.data;
          if (res.tokenAcesso) {
            onSignIn(res.tokenAcesso);
            validarSessao(atualizarUsuario);
            return history.push("/app");
          } else {
            text = "Não foi possível efetuar o login verifique as informações.";
            tipo = "error";
            alertMsg();
          }
        })
        .catch((e) => {
          console.log(e);

          const status = e.status;

          if (status === 400) {
            text =
              "Não foi possível efetuar o login, Verifique os dados informados e tente novamente.";
            tipo = "error";
            alertMsg();
          } else {
            text =
              "Não foi possível conectar-se ao servidor, Verifique sua conexão e tente novamente.";
            tipo = "error";
            alertMsg();
          }
        });
    }
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <Box>
      <Grid
        container
        height={window.innerHeight}
        style={{ background: "#3d79bd" }}
      >
        <Grid
          style={{ background: "#3d79bd" }}
          container
          direction="row"
          justifyContent="center"
        >
          {msgAlerta && (
            <div style={{ padding: 5, backgroundColor: "orange" }}>
              <h5>{msgAlerta}</h5>
            </div>
          )}
          <Grid item xs={12} md={4} style={{ textAlign: "center" }}>
            <img
              draggable="false"
              src={perto}
              alt=""
              style={{ width: "70%" }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              textAlign: "start",
              padding: !isMobile ? "0px 30% 0px 30%" : 10,
            }}
          >
            <form onSubmit={handleSubmit}>
              <FormTextField
                style={{
                  marginTop: "10px",
                  background: "#FFFF",
                  borderRadius: 10,
                }}
                id="CPF"
                label="CPF"
                variant="filled"
                type="number"
                pattern="[0-9]+"
                onChange={(event) => setCPF(event.target.value)}
                fullWidth
              />
              <br />
              <FormTextField
                fullWidth
                style={{
                  marginTop: "10px",
                  background: "#FFFF",
                  borderRadius: 10,
                }}
                id="senha"
                label="Senha"
                variant="filled"
                type="password"
                onChange={(event) => setSenha(event.target.value)}
              />
              <br />
              <Grid item style={{ textAlign: "center" }}>
                <ThemeProvider theme={theme}>
                  <Button
                    fullWidth
                    style={{
                      color: "white",
                      marginTop: "10px",
                      fontWeight: "bold",
                      width: "50%",
                      fontFamily: "Gilroy-ExtraBold",
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Entrar
                  </Button>
                </ThemeProvider>
              </Grid>
            </form>
          </Grid>

          {alerta && (
            <CustomizedSnackbars texto={text} tipo={tipo}></CustomizedSnackbars>
          )}
        </Grid>
        <Grid
          container
          style={{
            textAlign: "start",
            padding: !isMobile ? "10px 30% 0px 30%" : 10,
          }}
        >
          <Grid item xs={12} style={{ alignItems: "center", display: "flex" }}>
            <a
              href="/cadastro"
              style={{
                textDecoration: "none",
                color: "white",
                fontSize: "1.5rem",
              }}
            >
              Fazer meu cadastro
            </a>
          </Grid>
          <Grid item xs={12}>
            <a
              href="/redefinir-senha"
              style={{
                textDecoration: "none",
                color: "white",
                fontSize: "1.5rem",
              }}
            >
              Redefinir senha
            </a>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

const FormTextField = styled((props) => (
  <TextField
    InputProps={{
      style: {
        fontWeight: "bolder",
      },
      disableUnderline: true,
    }}
    InputLabelProps={{
      style: { color: "black", fontFamily: "Gilroy-ExtraBold" },
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiFilledInput-root": {
    borderRadius: 10,
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#eaeaea",
    },
  },
}));

const theme = createTheme({
  palette: {
    primary: {
      main: "#F5B01B",
    },
  },
});
